<!--
 * @Author: linqiushu
 * @Date: 2021-02-04 14:49:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-06 15:07:02
-->
<template>
    <div class="warp">
        <div class="print"  >
            <div id="printTest" ref="print" v-html="content" style="background-color: #FFFFFF;"></div>
        </div>
        <div class="t_center">
            <!-- <el-button type="primary" v-print="'#printTest'">打印报名表</el-button> -->
            <el-button type="primary" @click="print">打印</el-button>
            <router-link :to="{path:'/task/signin/index'}"><el-button style="margin-left:15px;">返回我的报考</el-button></router-link>
        </div>
    </div>
</template>
<script>

export default {
    name: '',
    components: {},
    data() {
        return {
            content:""
        }
    },
    created(){
        this.getData();
    },
    methods: {
        getData(){
            this.$store.dispatch("task/printSignupList").then(res => {
                this.content = res.data instanceof Array?'':res.data;
            })
        },
        print(){
            var oldStr = document.body.innerHTML;
            var newstr = document.getElementById('printTest').innerHTML
            document.body.innerHTML = newstr
            window.print()
            // 重新加载页面，以刷新数据
            document.body.innerHTML = oldStr;
            window.location.reload()
        }
    },
}
</script>
<style>
    @media print {
        html,body{background:#fff;}
    }
</style>
<style lang='scss' scoped>
	.warp{background:#fff;}
	.print{
		border: 1px solid #dcdcdc;
		margin: 20px 0;
		height: calc(100% - 122px);
		overflow-y:auto;
		padding:10px;
	}
	#printTest{padding:0;}
	@page{
		size:  a4;   /* auto is the initial value */
		/* margin: 3mm;  /* this affects the margin in the printer settings */ 
	}
	html{
		margin: 0px;  /* this affects the margin on the html before sending to printer */
	}
	body{
		border: solid 1px #fff ;
		margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
	}
</style>